// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ItemGroup-base__bXdcX{display:flex;flex-direction:column;width:var(--size-full)}.ItemGroup-header__O1zad{padding:var(--size-3) var(--size-3) var(--size-0) var(--size-3)}.ItemGroup-header__O1zad.ItemGroup-headerCollapsed__HXEHY{padding-bottom:var(--size-3)}.ItemGroup-itemsContainer__MdovI{display:flex;flex-direction:column;padding:var(--size-1)}.ItemGroup-separator__Yb089{padding:var(--size-1) var(--size-3)}.ItemGroup-truncationButton__Siivd{padding:var(--size-0) var(--size-4) var(--size-2_5) var(--size-4)}.ItemGroup-bottomDivider__OyiaL{padding:var(--size-0) var(--size-4)}.ItemGroup-dragging__ZwSwJ{z-index:var(--z-index-dragging-card)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ItemGroup-base__bXdcX",
	"header": "ItemGroup-header__O1zad",
	"headerCollapsed": "ItemGroup-headerCollapsed__HXEHY",
	"itemsContainer": "ItemGroup-itemsContainer__MdovI",
	"separator": "ItemGroup-separator__Yb089",
	"truncationButton": "ItemGroup-truncationButton__Siivd",
	"bottomDivider": "ItemGroup-bottomDivider__OyiaL",
	"dragging": "ItemGroup-dragging__ZwSwJ"
};
export default ___CSS_LOADER_EXPORT___;
